import { Record } from '../../transit'

const ListMeta = Record({
  count: 0,
  currentPage: 1,
  lastPage: 0,
  itemsPerPage: 0,
}, 'meta')

export default ListMeta



// WEBPACK FOOTER //
// ./src/common/lib/redux-lists/ListMeta.js